import { createAction, props } from '@ngrx/store';

export const ErrorActions = {
	error: {
		show: createAction('[Error] Show Error', props<{ payload: { message: string } }>()),
		hide: createAction('[Error] Hide Error'),
	},
};
